import { render } from "./DeleteAccount.vue?vue&type=template&id=cbe37d2a&scoped=true&lang=pug"
import script from "./DeleteAccount.vue?vue&type=script&lang=ts"
export * from "./DeleteAccount.vue?vue&type=script&lang=ts"

import "./DeleteAccount.vue?vue&type=style&index=0&id=cbe37d2a&lang=css"
import "./DeleteAccount.vue?vue&type=style&index=1&id=cbe37d2a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-cbe37d2a"

export default script